import { getChartExpressionStylingKey } from '@neptune/shared/custom-expressions-domain';

import { compileVegaLiteFloatSeriesQuery } from './vega-lite-float-series-compiler';
import type { VegaLiteFloatSeriesOptionsV2 } from './vega-lite-float-series-types';

export function getVegaLiteFloatPlotDescriptors(options: VegaLiteFloatSeriesOptionsV2) {
  const compiled = compileVegaLiteFloatSeriesQuery(options.query);
  return compiled.status === 'valid'
    ? compiled.query.y.map((y) => ({
        metricKey: y.metricKey,
        binding: y.as,
        dependencies: y.expression.attributes,
        xDependencies: compiled.query.xDependencies,
        label: y.alias || y.name,
        styleKey:
          y.kind === 'attribute'
            ? y.name
            : getChartExpressionStylingKey({ alias: y.alias || y.name, expression: y.name }),
      }))
    : [];
}
